<template>
	<v-layout row>
		<v-btn :disabled="disabled" @click="datepicker = true"
			>{{ label }} : {{ model | formatDate }}

			<v-icon @click.stop="remove" v-if="!disabled && model">close</v-icon>
		</v-btn>

		<div style="position:relative">
			<v-date-picker
				:hint="hint"
				persistent-hint
				first-day-of-week="1"
				v-on-clickaway="closeDatePicker"
				:min="min"
				no-title
				v-model="stringDate"
				v-if="datepicker"
				dark
				v-on:change="setDate()"
				color="secondary"
				class="fixed-error"
			></v-date-picker>
		</div>

		<!-- handling error and validator -->
		<v-text-field v-model="model" class="custom-error" :rules="computedRules"></v-text-field>
	</v-layout>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	mixins: [clickaway],
	props: {
		min: String,
	},
	data() {
		return {
			stringDate: null,
			datepicker: false,
		}
	},
	methods: {
		remove() {
			this.stringDate = null
			this.model = null
			this.datepicker = false
			this.update()
		},
		closeDatePicker() {
			this.datepicker = false
		},
		choseDate() {
			this.datepicker = false
		},
		setDate() {
			let date = new Date(this.stringDate)
			date.setHours(0)
			date.setMinutes(0)
			this.model = date
			this.datepicker = false
			this.update()
		},
	},
}
</script>
<style lang="scss">
.bo-input .v-picker.fixed-error {
	position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/inputs/dateInput.vue